module.exports = __webpack_public_path__ + "static/media/main.d0ed64c1.png";